import { Card, B1, P2, P1, TextLink, Button } from 'pfm-ui-components';
import { Row, Col } from 'react-awesome-styled-grid';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import {
  TRANSACTION_TYPE,
  SCHEME_OPTION_MAPPING,
  TRANSACTION_SOURCE,
} from '../../../constants/TransactionSuccessConstants';
import { hexToRgba, pxToRem } from '../../../styles/utils';
import DigiImage from '../../../../src/assets/images/digi-illustration.svg';
import { formatMoney } from '../../../utils/calculations';
import { HorizontalLineWithinCard } from '../../common/HorizontalLine';
import SuccessMessage from './SuccessMessage';
import Container from '../../common/Container';
import {
  getTransactionTypeMessage,
  getSuccessfulMessage,
  getSuccessfulTransactionIcon,
  getSuccessMessageDescription,
  getSucessfulTransactionDisclaimerMessage,
  getTransactionGoBackMessage,
  getTransactionGoBackUrl,
  isCancellationPageSuccessfulTransaction,
  shouldShowSeparatorTransactionPage,
  getInstallmentTitle,
  getSipScheduleTitle,
} from './utils';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAppContext } from '../../../store';
import { SWITCH } from '../../../constants/common';
import Footer from '../Footer';
import { routes } from '../../../config/routes';
import GTM from '../../../GTM';
import API from '../../../API';
import { useDeviceType } from '../../../utils/deviceType';
import DEVICE_TYPE from '../../../constants/device';
interface TransactionSuccessCardProps {
  refNo?: string; // reference number of the transaction done
  schemeName?: string; // scheme name
  fromSchemeName?: string; // from scheme name in the case of switch from one scheme to diff
  toSchemeName?: string; // to scheme name
  transactionType?: string; // Type of transaction can be one of SIP, Switch, Redeem, Invest, STP
  sipDate?: string; // Date of SIP payment to do
  sipScheduleDescription?: string; // detailed sheduled description of sip
  amount?: string | number; // amount of the sip/lumpsum
  units?: number;
  frequency?: string;
  freqDescription?: string;
  noOfInstallments?: number | string;
  isElss?: boolean; // should show Elss message or not
  isLumpsum?: boolean;
  transactionSource?: string;
  folioNo?: string;
  sipId?: string;
  execDate?: string;
  installmentAmount?: string;
  installmentUnits?: number;
  transactionStatus?: string;
  actionButtons?: Array<ActionButton>;
  subTransactionType?: string;
  queryParam?: any;
  schemeOption?: string;
  onGoBackMessageClick?: Function;
  isNfo?: boolean;
  investmentId?: string;
  userFlow?: string;
  isNomineeError?: boolean;
  nomineeError?: any;
  rta?: string;
}

interface SchemeData {
  title?: string;
  message?: string | number;
  description?: string;
}

interface ActionButton {
  label: string;
  onPress: Function;
}

// To display scheme details that includes schemeName, fromScheme, toScheme.
function showSchemeDetails(props: SchemeData) {
  const { title, message, description } = props;
  return (
    <StyledCol xs={12} md={6}>
      <StyledP2>{title}</StyledP2>
      <SchemeNameText>{message}</SchemeNameText>
      {description ? <SipMessageText>{description}</SipMessageText> : null}
    </StyledCol>
  );
}

// To display all the details of the transaction done
function showTransactionDetails(props: SchemeData) {
  const { title, message, description } = props;
  return (
    <StyledCol xs={6} md={4}>
      <StyledP2>{title}</StyledP2>
      <SchemeNameText>{message}</SchemeNameText>
      {description ? <SipMessageText>{description}</SipMessageText> : null}
    </StyledCol>
  );
}

export default function TransactionSuccessCard(props: TransactionSuccessCardProps) {
  const {
    refNo,
    schemeName,
    fromSchemeName,
    userFlow,
    toSchemeName,
    transactionType,
    sipDate,
    sipScheduleDescription,
    amount,
    units,
    frequency,
    freqDescription,
    noOfInstallments,
    isElss,
    isLumpsum,
    transactionSource,
    folioNo,
    sipId,
    execDate,
    installmentAmount,
    installmentUnits,
    transactionStatus,
    actionButtons,
    subTransactionType,
    queryParam,
    schemeOption,
    onGoBackMessageClick,
    isNfo,
    investmentId,
    isNomineeError,
    nomineeError,
    rta,
  } = props;

  const router = useRouter();
  const isCancellationPage = isCancellationPageSuccessfulTransaction(transactionType);
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;
  const { state, setState } = useAppContext();

  useEffect(() => {
    window.scroll(0, 0);
    if (userFlow && schemeName) GTM.transactInvest.onTransactionSuccessPageLoad(userFlow, schemeName);
  }, [schemeName]);

  const handleClickHere = () => {
    router.push(routes.TRANSACTION.url + `/${investmentId}`);
  };

  const postDigiGold = (path: string, params: any, method = 'post') => {
    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement('form');
    form.method = method;
    form.action = path;
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
    // const encodedToken = encodeURIComponent(params.data);
    // window.open(`${path}?data=${encodedToken}&origin=${params.origin}`, '_self');
  };

  const handleClick = () => {
    API.fetch(API.scheme.getDigiToken()).then((resp: any) => {
      const url = resp?.data?.data?.digiGoldUrl;
      const token = resp?.data?.data?.digiGoldTocken;
      postDigiGold(url.toString(), { data: token, origin: 'PFMV3' });
    });
  };

  const getNomineeErrorMessage = () => {
    return (
      <>
        <div>
          <b>Note: </b>We have observed in your folio that the nominee declaration (Opt-in/ Opt-out) is not available.
          As per the SEBI circular SEBI/HO/IMD/IMD-II DF3/P/CIR/2022/82 dated 15-06-2022, request you to update
          nomination at the earliest, failing which all debit transactions i.e. Redemption, Systematic Withdrawal Plan
          (SWP), Switch and Systematic Transfer Plan (STP) will be rejected by the respective AMCs w.e.f. 30th June
          2024. Request you to update your details with the AMC/ RTA {rta === 'CAMS' ? '(CAMS)' : '(KFintech)'} by
          visiting the mentioned link -
          <a
            href={
              rta === 'CAMS'
                ? 'https://digital.camsonline.com/changeofnomination'
                : 'https://mfs.kfintech.com/investor/General/NCTNomineeUpdation'
            }
            target="_blank"
          >
            {' '}
            {rta === 'CAMS'
              ? 'https://digital.camsonline.com/changeofnomination '
              : 'https://mfs.kfintech.com/investor/General/NCTNomineeUpdation '}
          </a>
          to avoid the transactions from getting rejected. Kindly ignore, if nomination details have already been
          updated
        </div>
      </>
    );
  };

  return (
    <Container>
      <SuccessMessageWrapper>
        <SuccessMessage
          icon={getSuccessfulTransactionIcon(transactionType)}
          successMessage={getSuccessfulMessage(transactionType)}
          description={getSuccessMessageDescription(transactionType, subTransactionType)}
        />
      </SuccessMessageWrapper>
      <Card>
        <StyledCard>
          <ReferenceDetailsContainer>
            {refNo ? (
              <>
                <StyledB1>Reference Number {refNo}</StyledB1>
              </>
            ) : null}
          </ReferenceDetailsContainer>

          <SchemeDetailsContainer isCancellationPage={isCancellationPage}>
            <StyledRow>
              {schemeName ? (
                <StyledCol xs={12} md={6}>
                  {transactionType === TRANSACTION_TYPE.REDEEM ? (
                    <StyledP2>Redemption Scheme Name</StyledP2>
                  ) : (
                    <StyledP2>Scheme Name</StyledP2>
                  )}
                  <SchemeNameText>{schemeName}</SchemeNameText>{' '}
                </StyledCol>
              ) : null}
              {fromSchemeName ? showSchemeDetails({ title: 'Switch from Scheme Name', message: fromSchemeName }) : null}
              {toSchemeName ? showSchemeDetails({ title: 'Switch To Scheme Name', message: toSchemeName }) : null}
              {sipDate
                ? showSchemeDetails({
                    title: getSipScheduleTitle(isNfo),
                    message: sipDate,
                    description: sipScheduleDescription,
                  })
                : null}
              {(isLumpsum ||
                transactionType === TRANSACTION_TYPE.REDEEM ||
                transactionType === TRANSACTION_TYPE.SWITCH) && (
                <StyledCol xs={12} md={6}>
                  <StyledP2>Transaction Type</StyledP2>
                  <SchemeNameText>{getTransactionTypeMessage(subTransactionType)}</SchemeNameText>
                </StyledCol>
              )}
              {schemeOption && (
                <StyledCol xs={12} md={6}>
                  <StyledP2>Scheme Option</StyledP2>
                  <SchemeNameText>{SCHEME_OPTION_MAPPING[schemeOption]}</SchemeNameText>
                </StyledCol>
              )}
              {amount && (transactionType === TRANSACTION_TYPE.INVEST || transactionType === TRANSACTION_TYPE.SIP)
                ? showSchemeDetails({ title: 'Amount ', message: formatMoney(amount, 0) })
                : null}
            </StyledRow>
          </SchemeDetailsContainer>
        </StyledCard>

        {isElss && (
          <ElssMessageWrapper>
            <ElssMessage>ELSS funds have lock in period of 3 years</ElssMessage>
          </ElssMessageWrapper>
        )}

        {shouldShowSeparatorTransactionPage(transactionType) && (
          <div>
            <HorizontalLineWithinCard />
          </div>
        )}

        <StyledCard>
          <StyledRow>
            {amount && (transactionType === TRANSACTION_TYPE.REDEEM || transactionType === TRANSACTION_TYPE.SWITCH)
              ? showTransactionDetails({ title: 'Amount', message: formatMoney(amount, 0) })
              : null}

            {units
              ? transactionType === TRANSACTION_TYPE.REDEEM
                ? showTransactionDetails({ title: 'Units Redeemed', message: units })
                : transactionType === TRANSACTION_TYPE.SWITCH &&
                  showTransactionDetails({ title: 'Units Switched', message: units })
              : null}

            {frequency
              ? showTransactionDetails({ title: 'Frequency', message: frequency, description: freqDescription })
              : null}

            {noOfInstallments
              ? showTransactionDetails({ title: getInstallmentTitle(transactionType), message: noOfInstallments })
              : null}

            {folioNo ? showTransactionDetails({ title: 'Folio Number', message: folioNo }) : null}

            {sipId ? showTransactionDetails({ title: 'Systematic plan id', message: sipId }) : null}

            {execDate ? showTransactionDetails({ title: 'Execution date', message: execDate }) : null}

            {installmentAmount
              ? showTransactionDetails({ title: 'Installment Amount', message: formatMoney(installmentAmount, 0) })
              : null}

            {installmentUnits
              ? showTransactionDetails({ title: 'Installment Units', message: installmentUnits })
              : null}

            {transactionStatus
              ? showTransactionDetails({ title: 'Transaction Status', message: transactionStatus })
              : null}
          </StyledRow>
        </StyledCard>

        {!isNfo && getSucessfulTransactionDisclaimerMessage(transactionType).length > 0 && (
          <DisclaimerCardWrapper>
            <DisclaimerMessage>
              {getSucessfulTransactionDisclaimerMessage(transactionType)}
              {/* <TextHighlight onClick={() => handleClickHere()}> Click Here </TextHighlight>
              to view transaction status */}
            </DisclaimerMessage>
            {isNomineeError && <DisclaimerMessage2>{getNomineeErrorMessage()}</DisclaimerMessage2>}
          </DisclaimerCardWrapper>
        )}
        {state.subCategory === 'GOLD' &&
          (isMobile ? (
            <>
              <FundCardWrapper>
                <DigiStyledP1>You may also be intreseted in exploring Digital Gold</DigiStyledP1>
                <CardWrapper2>
                  <CardWrapper3>
                    <TermsText>
                      Buy <strong> 24k Gold </strong> digitally and instantly without the hassle of storing it at your
                      end
                    </TermsText>
                    <BuyNowButton primary onClick={handleClick}>
                      Buy now
                    </BuyNowButton>
                  </CardWrapper3>
                  <div className="">
                    <StyledDigiImage />
                  </div>
                  {/* <ImageStyled src={digiImage}></ImageStyled> */}
                  {console.warn('test', DigiImage)}
                </CardWrapper2>
              </FundCardWrapper>
            </>
          ) : (
            <>
              <FundCardWrapper>
                {' '}
                <CardWrapper2>
                  {' '}
                  <CardWrapper3>
                    <DigiStyledP1>You may also be intreseted in exploring Digital Gold</DigiStyledP1>
                    <TermsText>
                      Buy <strong> 24k Gold </strong> digitally and instantly without the hassle of storing it at your
                      end
                    </TermsText>
                    <BuyNowButton primary onClick={handleClick}>
                      Buy now
                    </BuyNowButton>
                  </CardWrapper3>
                  <div className="">
                    <StyledDigiImage />
                  </div>
                  {/* <ImageStyled src={digiImage}></ImageStyled> */}
                  {console.warn('test', DigiImage)}
                </CardWrapper2>
              </FundCardWrapper>
            </>
          ))}
        {/* If the transaction type is stop sip i.e SIP Cancel then this code will be executed */}
        {transactionType === 'SIP Cancel' ? (
          <>
            <StyledCol>
              <ReasonsDescriptionWrapper enable={transactionType === 'SIP Cancel'}>
                <StyledP1>
                  The key to wealth creation is simple – keep investing and continue staying invested through the ups
                  and downs.
                  <StopSipSuccessPageNote
                    onClick={() => {
                      router.push(routes.EXPLORE.url);
                    }}
                  >
                    &nbsp;Click Here&nbsp;
                  </StopSipSuccessPageNote>
                  to view different funds basis your needs.
                </StyledP1>
              </ReasonsDescriptionWrapper>
            </StyledCol>
            <StyledCol>
              <ActionLinkContainerForStopSSIP>
                <TextLink
                  onClick={() => {
                    setState({ ...state, schemeListingState: null, insightPage: null });
                    onGoBackMessageClick(getTransactionGoBackMessage(transactionSource));
                    transactionSource === TRANSACTION_SOURCE.MUTUAL_FUND
                      ? router.push(getTransactionGoBackUrl(transactionSource).url, undefined, {
                          shallow: true,
                        })
                      : router.push(getTransactionGoBackUrl(transactionSource).url + '/' + queryParam, undefined, {
                          shallow: true,
                        });
                  }}
                >
                  {getTransactionGoBackMessage(transactionSource)}
                </TextLink>
              </ActionLinkContainerForStopSSIP>
            </StyledCol>
          </>
        ) : (
          <FooterCardContainer isCancellationPage={isCancellationPage}>
            {actionButtons ? (
              <ActioButtonsContainer>
                {actionButtons.map((actionButton, index) => {
                  return (
                    <StyledButton
                      key={`action-button-success-page-${transactionType}-${index}`}
                      secondary
                      onClick={() => {
                        setState({ ...state, schemeListingState: null, insightPage: null });
                        actionButton.onPress();
                      }}
                    >
                      {actionButton.label}
                    </StyledButton>
                  );
                })}
              </ActioButtonsContainer>
            ) : null}
            <ActionLinkContainer>
              <TextLink
                onClick={() => {
                  setState({ ...state, schemeListingState: null, insightPage: null });
                  onGoBackMessageClick(getTransactionGoBackMessage(transactionSource));
                  transactionSource === TRANSACTION_SOURCE.MUTUAL_FUND
                    ? router.push(getTransactionGoBackUrl(transactionSource).url, undefined, {
                        shallow: true,
                      })
                    : router.push(getTransactionGoBackUrl(transactionSource).url + '/' + queryParam, undefined, {
                        shallow: true,
                      });
                }}
              >
                {getTransactionGoBackMessage(transactionSource)}
              </TextLink>
            </ActionLinkContainer>
          </FooterCardContainer>
        )}
      </Card>
      <FooterWrapper>
        <Footer hasNavigationBar={false} />
      </FooterWrapper>
    </Container>
  );
}

const TextHighlight = styled.span`
  color: ${(props) => props.theme.palette.burgundy1};
  cursor: pointer;
`;

const FooterWrapper = styled.div`
  margin-top: ${pxToRem(96)};
`;
const SuccessMessageWrapper = styled.div`
  margin-top: ${pxToRem(24)};
  ${up('md')} {
    margin-top: ${pxToRem(48)};
  }
`;
const StyledCard = styled.div`
  padding: ${pxToRem(16)};
  padding-bottom: 0;

  ${up('md')} {
    padding: ${pxToRem(24)};
    padding-bottom: 0;
  }
`;

const StyledB1 = styled(B1)`
  color: ${(props) => props.theme.palette.grey2};
`;

const StyledP2 = styled(P2)`
  color: ${(props) => props.theme.palette.grey3};
`;

const SipMessageText = styled(P2)`
  font-size: ${pxToRem(12)};
  color: ${(props) => props.theme.palette.grey2};
  line-height: ${pxToRem(14)};
`;

const StyledRow = styled(Row)`
  margin: 0;
`;

const StyledCol = styled(Col)`
  padding-left: 0;
  margin-bottom: ${pxToRem(24)};
  ${up('md')} {
    margin-bottom: ${pxToRem(24)};
  }
`;
const SchemeNameText = styled(B1)`
  color: #4a4a4a;
`;

const ReferenceDetailsContainer = styled.div``;
const SchemeDetailsContainer = styled.div<{ isCancellationPage: boolean }>`
  margin-top: ${(props) => (props.isCancellationPage ? '0' : `${pxToRem(16)}`)};
  ${up('md')} {
    margin-top: ${(props) => (props.isCancellationPage ? '0' : `${pxToRem(32)}`)};
  }
`;

const DisclaimerCardWrapper = styled.div`
  background: #f6f7f8;
  padding-bottom: ${pxToRem(16)};
`;

const DisclaimerMessage = styled(P2)`
  font-style: italic;
  color: ${(props) => props.theme.palette.grey2};
  padding: ${pxToRem(14)} ${pxToRem(12)} ${pxToRem(14)} ${pxToRem(12)};
  ${up('md')} {
    padding: ${pxToRem(16)} ${pxToRem(24)} ${pxToRem(16)} ${pxToRem(24)};
  }
`;

const ElssMessage = styled(SipMessageText)`
  font-style: italic;
`;

const ElssMessageWrapper = styled.div`
  margin: 0 ${pxToRem(16)} ${pxToRem(8)} ${pxToRem(16)};
  ${up('md')} {
    margin: 0 ${pxToRem(24)} ${pxToRem(16)} ${pxToRem(24)};
  }
`;
const FooterCardContainer = styled.div<{ isCancellationPage: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: ${pxToRem(24)} 0 ${pxToRem(16)} 0;
  padding-top: ${(props) => (props.isCancellationPage ? '0' : `${pxToRem(24)}`)};
  ${up('md')} {
    flex-direction: ${(props) => (props.isCancellationPage ? 'row-reverse' : 'row')};
    align-content: center;
    padding: ${pxToRem(16)} ${pxToRem(24)} ${pxToRem(24)} ${pxToRem(16)};
    padding-top: ${(props) => (props.isCancellationPage ? `${pxToRem(24)}` : `${pxToRem(16)}`)};
  }
`;

const ActioButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${up('md')} {
    flex-direction: row;
  }
`;

const StyledButton = styled(Button)`
  margin: ${pxToRem(4)} ${pxToRem(8)};
  align-self: center;
  :hover {
    background-color: transparent;
  }
`;

const ActionLinkContainerForStopSSIP = styled.div`
  align-self: center;
  cursor: pointer;
  margin-top: ${pxToRem(-10)};
  margin-bottom: ${pxToRem(20)};
  ${up('md')} {
    align-self: flex-end;
    margin-right: ${pxToRem(30)};
  }
`;

const ActionLinkContainer = styled.div`
  align-self: center;
  cursor: pointer;
  margin-top: ${pxToRem(24)};
  ${up('md')} {
    margin-top: 0;
  }
`;
const ReasonsDescriptionWrapper = styled.article<{ enable: boolean }>`
  display: ${(props) => (props.enable ? 'inline-block' : 'none')};
  background-color: ${(props) => props.theme.palette.whiteGrey4};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  width: 95%;
  border-radius: ${pxToRem(8)};
  margin-left: ${pxToRem(15)};
  ${up('md')} {
    padding: ${pxToRem(16)} ${pxToRem(24)};
  }
`;
const StyledP1 = styled(P1)`
  color: ${(props) => props.theme.palette.grey2};
  align-self: center;
`;
const StopSipSuccessPageNote = styled.span`
  color: ${(props) => props.theme.palette.burgundy1};
  padding: 0;
  margin: 0;
  margin-block-end: 0;
  margin-block-start: 0;
  cursor: pointer;
`;

const CardWrapper2 = styled.div`
  display: flex;
  flex-direction: row;
  flex: 100%;
`;
const CardWrapper3 = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  justify-content: space-around;
  flex: 100%;
`;
const BuyNowButton = styled(Button)`
  width: fit-content;
`;
const StyledDigiImage = styled(DigiImage)`
  width: 150px;
  margin-left: -20px;
  height: auto;
  box-sizing: content-box;
  ${up('sm')} {
    width: 200px;
    margin: 0px;
  }
`;
const TermsText = styled(P2)`
  font-size: 0.9rem;
  font-weight: normal;
  cursor: default;
  color: #97144d;
`;
const DigiStyledP1 = styled(P1)`
  font-size: 12px;
  font-style: italic;
  margin-top: 12px;
  margin-left: 10px;
  ${up('sm')} {
    margin: 0px;
  }
`;
const P1Styled = styled(P1)`
  color: #4a4a4a;
  font-weight: 550;
  cursor: pointer;
  padding-bottom: ${pxToRem(8)};
  ${up('md')} {
    &:hover {
      text-decoration: underline;
    }
  }
`;
const ImageStyled = styled.img`
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  ${up('md')} {
    margin: 0 ${pxToRem(24)};
    width: ${pxToRem(48)};
    height: ${pxToRem(48)};
  }
`;
const FundCardWrapper = styled(Card)`
  padding: ${pxToRem(0)} ${pxToRem(8)};
  margin: ${pxToRem(6)} 0;
  border-radius: 12px;
  ${up('md')} {
    /* cursor: pointer; */
    padding: ${pxToRem(8)};
    margin: 1px 0 0 0;
    &:hover {
      ${P1Styled} {
        text-decoration: underline;
      }
      box-shadow: ${(props) => `0 2px 20px ${hexToRgba(props.theme.palette.burgundy1, 0.4)}`};
      ${up('md')} {
        margin: ${pxToRem(2)} 0;
      }
    }

    /* To make first round on top right and top left corner in web mode only */
    ${(props) => props.isFirst && 'border-radius:8px 8px 0 0'}

    /* To make last round on bottom right and top left corner in web mode only */
    ${(props) => props.isLast && 'border-radius: 0 0 8px 8px'}
  }
`;

const DisclaimerMessage2 = styled(P2)`
  font-style: italic;
  color: ${(props) => props.theme.palette.grey2};
  padding: ${pxToRem(0)} ${pxToRem(12)} ${pxToRem(0)} ${pxToRem(12)};
  ${up('md')} {
    padding: ${pxToRem(0)} ${pxToRem(24)} ${pxToRem(0)} ${pxToRem(24)};
  }
`;
